export default "__VITE_ASSET__CI1TX8Xu__"